import { Image as _Image, ImageProps as _ImageProps } from 'antd'

import { SyntheticEvent, memo, useState } from 'react'

type ImageProps = _ImageProps

function ImageMemo({ style, ...props }: ImageProps) {
  const [error, setError] = useState<SyntheticEvent<
    HTMLImageElement,
    Event
  > | null>(null)

  if (!props?.src) {
    return
  }

  if (error) {
    return (
      <_Image
        {...props}
        src="/logos/logo-name.svg"
        preview={false}
        style={{
          objectFit: 'contain',
          ...style,
        }}
        loading="lazy"
      />
    )
  }

  return (
    <_Image
      onError={(error) => setError(error)}
      preview={false}
      style={{
        objectFit: 'cover',
        ...style,
      }}
      loading="lazy"
      {...props}
    />
  )
}

const Image = memo(ImageMemo)

export default Image
